import React, { useEffect, useState } from "react"
import DataTable from "../../../components/atoms/table/DataTable.atom"
import Column from "../../../components/atoms/table/Column.atom"
import FollowedTaskItem from "./FollowedTaskItem.compound"
import { clsx } from "../../../utils/strings.utils"
import { ReactComponent as CelebrateIcon } from "../../../design/assests/images/icons/celebrate.svg"
import { unfollowTaskById } from "../../../services/followedTask.service"

const MyFollowedTasksDataTable = React.forwardRef(
  (
    {
      tasks = [],
      activeTeamMembers = [],
      showLoading = false,
      loading = false,
      triggerRefresh,
      height,
      virtualScrollerOptions,
      emptyCustomMessage,
    },
    ref
  ) => {
    // const memoizedTasks = useMemo(() => tasks, [tasks])
    const [isFirstRender, setIsFirstRender] = useState(true)

    useEffect(() => {
      if (isFirstRender) {
        setIsFirstRender(false)
      }
    }, [])

    return (
      <DataTable
        ref={ref}
        className={clsx("followed-tasks-table pending-tasks-list")}
        value={tasks}
        responsiveLayout="scroll"
        noSameWidthColumns
        noFixedColumns
        withOutHeader
        virtualScrollerOptions={virtualScrollerOptions}
        onValueChange={() => {
          ref?.current?.resetScroll()
        }}
        scrollable
        style={{ height: "100%" }}
        tableStyle={{
          tableLayout: "fixed",
          height: height,
          minHeight: height,
          maxHeight: height,
        }}
        emptyCustomMessage={emptyCustomMessage}
      >
        <Column
          body={(rowData) => (
            <FollowedTaskItem
              key={rowData.id}
              {...rowData}
              activeTeamMembers={activeTeamMembers}
              finishService={() => {
                unfollowTaskById(rowData.id).then(() => {
                  triggerRefresh()
                })
              }}
            />
          )}
          style={{
            padding: "0",
          }}
        />
      </DataTable>
    )
  }
)

export default MyFollowedTasksDataTable
